// extracted by mini-css-extract-plugin
export default {"container":"LoadingProvider_container__4K93U"};